// @flow

import { TownSiteEditor } from "./town-site-editor";

export default TownSiteEditor;